import React, { useState } from "react";
import { DailogBox } from "../../../components/Elements/DailogBox/DailogBox";
import { Badge } from "../../../components/Elements/TextStyles/Badge";
import { Button, Checkbox } from "antd";
import { THEME_COLORS } from "../../../color";

const ProjectReportFilter = ({ onOpen, onClose, setStatus }) => {
  const [checkedItems, setCheckedItems] = useState({
    inProcess: false,
    Completed: false,
    Rejected: false,
  });

  const handleCheckboxChange = (e) => {
    setCheckedItems({ ...checkedItems, [e.target.name]: e.target.checked });
  };

  const handleSave = () => {
    const selectedStatuses = Object.keys(checkedItems).filter(
      (key) => checkedItems[key]
    );

    setStatus(selectedStatuses);
    onClose(); // Close dialog after saving
  };

  const handleCancel = () => {
    setCheckedItems({ inProcess: false, Completed: false, Rejected: false }); // Uncheck all
    onClose(); // Close dialog
  };

  return (
    <DailogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="700px">
      <div>
        <h3 className="text-xl text-[#06513D]">Filter</h3>
      </div>
      <div
        style={{
          border: "1px solid #ebedf3",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <div className="flex-col">
          <div className="flex justify-between my-4 mx-10">
            <Badge text="In-Process" />
            <Checkbox
              name="inProcess"
              checked={checkedItems.inProcess}
              onChange={handleCheckboxChange}
              className="custom-green-checkbox"
            />
          </div>
          <hr className="mx-8" />
          <div className="flex justify-between my-4 mx-10">
            <Badge text="Completed" />
            <Checkbox
              name="Completed"
              checked={checkedItems.Completed}
              onChange={handleCheckboxChange}
              className="custom-green-checkbox"
            />
          </div>
          <hr className="mx-8" />
          <div className="flex justify-between my-4 mx-10">
            <Badge text="Rejected" />
            <Checkbox
              name="Rejected"
              checked={checkedItems.Rejected}
              onChange={handleCheckboxChange}
              className="custom-green-checkbox"
            />
          </div>
          <hr className="mx-8" />
        </div>
        {/* <div className="flex justify-center px-20 gap-10 my-10">
          <button
            style={{
              background: "#e7fefe",
              height: "40px",
              width: "150px",
              borderRadius: "10px",
              border: "1px solid #06513D",
            }}
            className="text-base font-normal text-[#06513D]"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            style={{
              background: THEME_COLORS.green,
              height: "40px",
              width: "150px",
              borderRadius: "10px",
            }}
            className="text-base font-normal text-white"
            onClick={handleSave}
          >
            Save
          </button>
        </div> */}

        <div className="flex flex-row justify-between gap-4 px-4 my-10">
          <button
            style={{
              background: "#e7fefe",
              height: "40px",
              flex: 1,
              borderRadius: "10px",
              border: "1px solid #06513D",
            }}
            className="text-base font-normal text-[#06513D] hover:!bg-[#F8F8F8]"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            style={{
              background: THEME_COLORS.green,
              height: "40px",
              flex: 1,
              borderRadius: "10px",
            }}
            className="text-base font-normal text-white hover:!bg-[#387464]"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    </DailogBox>
  );
};

export default ProjectReportFilter;
